module.exports = __webpack_public_path__ + "img/play-btn.de82848d.svg";